module.exports = __webpack_public_path__ + "static/media/arrow_down.ec7a02d9.svg";